import React, { useRef } from 'react';
import QRCode from 'react-qr-code';

function GeneradorQR({urlDestino}) {

  const qrCodeRef = useRef(); // Crea una referencia para el elemento SVG del QR


  const downloadQRCode = () => {
    if (qrCodeRef.current) {
      // Obtiene el elemento SVG
      const svgElement = qrCodeRef.current.querySelector('svg'); 
      if (!svgElement) {
        console.error("No se encontró el elemento SVG del QR.");
        return;
      }

      // Serializa el SVG a una cadena de texto
      const svgData = new XMLSerializer().serializeToString(svgElement);
      // Crea un Blob con el tipo SVG
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
      // Crea una URL para el Blob
      const svgUrl = URL.createObjectURL(svgBlob);

      // Crea un enlace temporal para la descarga
      const downloadLink = document.createElement('a');
      downloadLink.href = svgUrl;
      downloadLink.download = 'codigo-qr.svg'; // Nombre del archivo a descargar
      document.body.appendChild(downloadLink); // Añade el enlace al DOM temporalmente
      downloadLink.click(); // Simula un clic para iniciar la descarga
      document.body.removeChild(downloadLink); // Elimina el enlace del DOM
      URL.revokeObjectURL(svgUrl); // Libera la URL del objeto
    }
  };


  return (
    <div style={{ padding: "20px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>

      <p>Escanea este código para ir a: {urlDestino}</p>

      
      <div ref={qrCodeRef} style={{ background: 'white', padding: '16px' }}>
        <QRCode
          value={urlDestino}
          size={256}
          viewBox={`0 0 256 256`}
        />
      </div>

      <button 
        onClick={downloadQRCode} 
        style={{ 
          marginTop: "20px", 
          padding: "10px 20px", 
          fontSize: "1em", 
          cursor: "pointer",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px"
        }}
      >
        Descargar QR como SVG
      </button>
      <p style={{ marginTop: "20px", fontSize: "0.9em", color: "#666" }}>
        ¡Asegúrate de que la URL sea la correcta!
      </p>
    </div>
  );
}

export default GeneradorQR;